import React, { useEffect, useState } from "react";
import { ReactComponent as PlayIcon } from "../../../assets/Icons/play.svg";
import { useSelector } from "react-redux";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/effect-fade";
import "swiper/css/autoplay";
import { ReactComponent as PremiumIcon } from "../../../assets/Icons/premium.svg";

import { EffectFade, Thumbs, Autoplay } from "swiper";
import { Link, useNavigate } from "react-router-dom";
import BannerUtil from "./util.jsx";
import { imageUrlCheck, getDeviceType } from "../../../utils/utils";
import Translate from "../../../Components/Multilanguage/Translate";
const Featured = ({ data }) => {
  const [activeThumb, setActiveThumb] = useState();
  const navigate = useNavigate();
  const { playClickHandler } = BannerUtil();
  const deviceType = getDeviceType();
  console.log('deviceType', deviceType);

  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  return (
    <div className="featured" role="region" aria-label="Featured Shows">
      <Swiper
        onSwiper={setActiveThumb}
        slidesPerView={1}
        watchSlidesProgress
        effect={"fade"}
        spaceBetween={0}
        className="mySwiper"
        modules={[EffectFade, Thumbs]}
        allowTouchMove={false}
        // allowSlideNext={false}
        // allowSlidePrev={false}
        aria-live="polite"
      >
        {data?.shows?.map((item, index) => (
          <SwiperSlide key={index}>
            <div
              className="bgImageContainer"
              style={{
                backgroundImage: `url(${imageUrlCheck(item?.banner)
                  ? (deviceType === 'mobile' ? item?.banner_portrait : item?.banner)
                  : `${process.env.REACT_APP_IMAGE_URL}${deviceType === 'mobile' ? item?.banner_portrait : item?.banner}`})`
              }}
            >
            </div>
            <div className="contents">
              <h1 className="title">
                {(item?.image_title && imageUrlCheck(`${item.image_title}`)) ? (
                  <img src={`${item.image_title}`} alt={item.image_title || item.show_name} className="titleImage" />
                ) : (
                  (projectInfo?.projectConfig?.pubid === 50046 ? null : item?.show_name)
                )}
              </h1>
              <span className="line" aria-hidden="true"></span>
              <div className="containers">
                {projectInfo?.projectConfig?.pubid !== 50183 && (
                  <div className="left">
                    <div className="activeThumb">
                      <div
                        className="imageContainer"
                        onClick={() => playClickHandler(item)}
                        role="button"
                        aria-label={`Play ${item?.show_name}`}
                        tabIndex={0}
                        onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') playClickHandler(item); }}
                        style={{ outline: 'none' }}
                      >
                        {
                          imageUrlCheck(item?.banner) ? (
                            <img src={item?.banner_portrait} alt={item?.show_name ? `${item.show_name} thumbnail` : "Show thumbnail"} />
                          ) : (
                            <img src={`${process.env.REACT_APP_IMAGE_URL}${item?.banner_portrait}`} alt={item?.show_name ? `${item.show_name} thumbnail` : "Show thumbnail"} />
                          )
                        }
                      </div>
                    </div>
                  </div>
                )}
                <div className="right">
                  <div className="metaData">
                    <div className={`datas ${projectInfo?.projectConfig?.pubid == 50183 ? 'pubid-50183' : ''}`}>
                      <span className="year">{item?.year}</span>
                      <span className={`duration ${item?.year && 'showDot'} ${/^[A-Za-z0-9\s]+$/.test(item?.duration_text) ? "ltr" : ""}`}>{item?.duration_text}</span>
                      <span className="certificate">{item?.rating}</span>
                      <div className="genres" aria-label="Genres">
                        {/* {
                          item?.category_names?.map((item,index)=>(
                            <span key={index}>{item}</span>

                          ))
                        } */}
                      </div>
                    </div>

                    <div
                      className={`buttonContainer ${projectInfo?.projectConfig?.pubid === 50140 ? 'no-flex' : ''} ${projectInfo?.projectConfig?.pubid == 50183 ? 'pubid-50183' : ''}`}
                      onClick={() =>
                        playClickHandler(item)}
                      role="button"
                      aria-label={`Watch now: ${item?.show_name}`}
                      tabIndex={0}
                      onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') playClickHandler(item); }}
                      style={{ outline: 'none' }}
                    >
                      <PlayIcon aria-hidden="true" />
                      <span><Translate textKey={'watch_now'} /></span>
                      {projectInfo?.projectConfig?.pubid !== 50140 && (
                        item?.is_free_video ? (
                          <span className="free"><Translate textKey={'free'} /></span>
                        ) : (
                          <PremiumIcon aria-label="Premium" />
                        )
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bottomGradient" aria-hidden="true" />
          </SwiperSlide>
        ))}
      </Swiper>

      <div className={`gallerySection ${projectInfo?.projectConfig?.pubid == 50183 ? 'pubid-50183' : ''}`} role="region" aria-label="Gallery Thumbnails">
        <Swiper
          slidesPerView={projectInfo?.projectConfig?.pubid == 50183 ? 4 : 3}
          watchSlidesProgress={true}
          spaceBetween={15}
          loop={true}
          className="mySwiper"
          centeredSlides={true}
          // allowSlideNext={false}
          // allowSlidePrev={false}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          modules={[Thumbs, Autoplay]}
          thumbs={{ swiper: activeThumb }}
          slideToClickedSlide={true}
          aria-label="Gallery carousel"
        >
          {data?.shows?.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="imageContainer" role="button" aria-label={`Select ${item?.show_name}`} tabIndex={0} onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') activeThumb.slideTo(index); }}>
                {
                  imageUrlCheck(item?.banner) ? (
                    <img src={item?.banner_portrait} alt={item?.show_name ? `${item.show_name} gallery image` : "Gallery image"} />
                  ) : (
                    <img src={`${process.env.REACT_APP_IMAGE_URL}${item?.banner_portrait}`} alt={item?.show_name ? `${item.show_name} gallery image` : "Gallery image"} />
                  )
                }
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Featured;